export const SET_MANAGE_OPTIONS_LIST = 'SET_MANAGE_OPTIONS_LIST';
export const SET_MANAGE_SELECTED_OPTION = 'SET_MANAGE_SELECTED_OPTION';
